export default __webpack_public_path__ + "static/media/ic-mail-with-arrow.b24b5de4.svg";